import { WebClientApiErrorResult } from '../WebClientApiResponse';
import { NoInputVizPortalClientMethod } from '../VizPortalClientMethod';

export interface LogoutSuccessResult {
  redirectUrl: string;
}

export type LogoutResult = LogoutSuccessResult | WebClientApiErrorResult;

export const LogoutMethod = new NoInputVizPortalClientMethod<LogoutResult>('logout');
